import React from "react";
import ProfileProvider from "./ProfileContext";
import LanguagesProvider from "./LanguagesContext";
import QuestionProvider from "./QuestionsContext";
import AttemptedQuestionsProvider from "./AttemptedQuestionsContext";
import QuestionRecordProvider from "./QuestionRecord";
import OptionRecordProvider from "./OptionRecord";
import { useCheatingWatcher } from "./useCheatingWatcher";
import TimeLeftProvider from "./TimeLeftContext";
import TimerProvider from "./TimerContext";
import CodingLanguagesProvider from "./CodingLanguageContext";

function ContextProvider({ children }) {
  // useCheatingWatcher()
  return (
    <TimerProvider>
      <TimeLeftProvider>
        <QuestionRecordProvider>
          <OptionRecordProvider>
            <ProfileProvider>
              <QuestionProvider>
                <LanguagesProvider>
                  <AttemptedQuestionsProvider>
                    <CodingLanguagesProvider>
                      {children}
                    </CodingLanguagesProvider>
                  </AttemptedQuestionsProvider>
                </LanguagesProvider>
              </QuestionProvider>
            </ProfileProvider>
          </OptionRecordProvider>
        </QuestionRecordProvider>
      </TimeLeftProvider>
    </TimerProvider>
  );
}

export default ContextProvider;
